import React from 'react';

export const IconArrowLeft = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M0.292893219,0.292893219 C0.65337718,-0.0675907428 1.22060824,-0.0953202783 1.61289944,0.209704612 L1.70710678,0.292893219 L6.70710678,5.29289322 C7.06759074,5.65337718 7.09532028,6.22060824 6.79029539,6.61289944 L6.70710678,6.70710678 L1.70710678,11.7071068 C1.31658249,12.0976311 0.683417511,12.0976311 0.292893219,11.7071068 C-0.0675907428,11.3466228 -0.0953202783,10.7793918 0.209704612,10.3871006 L0.292893219,10.2928932 L4.585,6 L0.292893219,1.70710678 C-0.0675907428,1.34662282 -0.0953202783,0.779391764 0.209704612,0.387100557 L0.292893219,0.292893219 Z"
				transform="matrix(-1 0 0 1 7 0)"
			/>
		</svg>
	);
};
